import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostSucceed, EGetPostActionType } from './types';
import { IPost } from '../../../types/post';

export const getPostSucceed: (data: IPost) => TGetPostSucceed = actionGenerator<EGetPostActionType.Succeed, IPost>(
  EGetPostActionType.Succeed,
);
